
(function systemTranslateFilterModuleDefinition() {

    'use strict';

    angular.module('SystemTranslateFilter', ['pascalprecht.translate'])
           .filter('systemTranslate', ['$filter', function systemTranslateFilterFactory($filter) {
               /*
               Filtro de traducción solo para textos que comienzan con #
               */
               var translateFilter = $filter('translate');

               var sysTranslateFilter = function (translationId, interpolateParams, interpolation) {

                   if (translationId.length && translationId.charAt(0) === '#') {
                       return translateFilter(translationId.substring(1), interpolateParams, interpolation);
                   }

                   return translationId;
               };

               return sysTranslateFilter;

           }]);

})();